"use client";
import { useCallback, useEffect } from "react";
import { usePathname } from "next/navigation";
import { useItemRedirect } from "@/utils/useItemRedirect";
import { focusItemCard } from "@/utils/focusItemCard";
import { ROUTE_SHOP } from "@/utils/constants";
import { Menu } from "@/dto/menu";

interface ShopMenuInteractionsProps {
  menu: Menu | null;
}

export const ShopMenuInteractions = ({ menu }: ShopMenuInteractionsProps) => {
  const pathname = usePathname();

  const constructUrlAction = useCallback(
    (itemUrl: string) => `${ROUTE_SHOP}/${itemUrl}`,
    []
  );

  useItemRedirect({
    ignorePath: ROUTE_SHOP,
    constructUrlAction,
    items: menu?.items,
  });

  useEffect(() => {
    if (pathname === ROUTE_SHOP) {
      focusItemCard();
    }
  }, []);

  return null;
};
